(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaia-finder-chat"]) return;
  try {
    
function createMeasurement({read, write, remove, send, now, id, environment}) {
  const key = 'gaia-finder:measurement:1:' + environment;
  const ttl = 30 * 60 * 1000;
  const enums = {
    mode: ['aroma', 'purpose', 'learn'],
    use: ['perfume', 'skincare', 'soap', 'candle', 'ritual'],
    family: ['floral', 'citrus', 'woody', 'resin', 'herbal', 'sweet', 'powdery', 'earthy', 'any'],
    type: ['essential', 'co2', 'absolute', 'enfleurage', 'wax', 'carrier', 'resin', 'any'],
    role: ['aroma', 'extract', 'carrier', 'any'],
    step: ['mode', 'use', 'family', 'type', 'role', 'moment', 'results'],
    feedback: ['yes', 'not_quite'],
    help_topic: ['ingredient_choice', 'how_to_use', 'product_types', 'shipping_orders', 'other'],
    error: ['module_load', 'product_lookup', 'partial_results']
  };
  let allowed = false;
  let state = null;
  const safely = fn => { try { return fn(); } catch (error) {} };
  function session() {
    if (!state || now() - state.last > ttl) {
      state = {session: id(), run: null, seen: [], last: now()};
    }
    return state;
  }
  function clean(data) {
    const out = {};
    for (const [name, values] of Object.entries(enums)) {
      if (values.includes(data[name])) out['gf_' + name] = data[name];
    }
    for (const name of ['result_count', 'rank']) {
      if (Number.isInteger(data[name]) && data[name] >= 0 && data[name] <= 3) out['gf_' + name] = data[name];
    }
    if (/^\d{5,20}$/.test(String(data.item_id || ''))) out.gf_item_id = String(data.item_id);
    const ids = String(data.recommended_ids || '').split(',').filter(x => /^\d{5,20}$/.test(x)).slice(0, 3);
    if (ids.length) out.gf_recommended_ids = ids.join(',');
    return out;
  }
  function emit(name, data = {}, once = '') {
    if (!allowed || !['exposed', 'open', 'start', 'resume', 'step', 'answer', 'results', 'results_update', 'product_click', 'feedback', 'need_help', 'help_topic', 'contact_click', 'close', 'reset', 'error'].includes(name)) return false;
    const s = session();
    const token = once && (['exposed', 'open'].includes(name) ? 'session' : (s.run || 'session')) + ':' + name + ':' + once;
    if (token && s.seen.includes(token)) return false;
    const payload = {gf_version: '1', gf_environment: environment, gf_session_id: s.session, ...clean(data)};
    if (s.run) payload.gf_run_id = s.run;
    try { if (send(name, payload) === false) return false; } catch (error) { return false; }
    if (token) s.seen.push(token);
    s.seen = s.seen.slice(-200);
    s.last = now();
    safely(() => write(key, JSON.stringify(s)));
    return true;
  }
  return {
    consent(value) {
      if (value === allowed) return;
      allowed = value === true;
      state = null;
      if (!allowed) { safely(() => remove(key)); return; }
      const stored = safely(() => JSON.parse(read(key)));
      if (stored && typeof stored.session === 'string' && /^[a-zA-Z0-9-]{1,64}$/.test(stored.session) && (stored.run === null || /^[a-zA-Z0-9-]{1,64}$/.test(stored.run)) && Array.isArray(stored.seen) && stored.seen.every(x => typeof x === 'string') && now() - stored.last >= 0 && now() - stored.last < ttl) state = stored;
    },
    event(name, data = {}, once = '') { return safely(() => emit(name, data, once)) || false; },
    start(data = {}, resumed = false) {
      if (!allowed) return;
      const s = session();
      if (!s.run) { s.run = id(); emit(resumed ? 'resume' : 'start', data, 'once'); }
    },
    reset() {
      if (!allowed) return;
      emit('reset');
      session().run = null;
      safely(() => write(key, JSON.stringify(state)));
    }
  };
}

function attachMeasurement(root, config) {
  const themeRole = window.Shopify?.theme?.role;
  const environment = themeRole && themeRole !== 'main' ? 'preview' : config.measurement_environment;
  root.dataset.measurementEnvironment = environment;
  if (environment === 'preview') root.dataset.preview = 'true';
  const tracker = createMeasurement({
    read: key => sessionStorage.getItem(key),
    write: (key, value) => sessionStorage.setItem(key, value),
    remove: key => sessionStorage.removeItem(key),
    now: () => Date.now(),
    id: () => crypto.randomUUID(),
    environment,
    send: (name, data) => {
      if (config.measurement_enabled !== true || !window.Shopify?.analytics?.publish) return false;
      const sent = window.Shopify.analytics.publish('gaia_finder_' + name, data);
      if (environment === 'preview') console.info('[Gaia Finder] published', name, JSON.stringify(data));
      return sent !== false;
    }
  });
  function updateConsent() {
    try {
      tracker.consent(config.measurement_enabled === true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true);
      if (root.isConnected && !document.hidden) tracker.event('exposed', {}, 'once');
    } catch (error) { tracker.consent(false); }
  }
  document.addEventListener('visitorConsentCollected', updateConsent);
  document.addEventListener('visibilitychange', updateConsent);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => { if (!error) updateConsent(); });
  updateConsent();
  return tracker;
}

if (!customElements.get('gaia-product-finder')) {
  customElements.define('gaia-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.finderReady) return;
      this.finderReady = true;
      const shell = this.querySelector('.gf-shell');
      const launcher = this.querySelector('.gf-launcher');
      const body = this.querySelector('[data-gf-body]');
      const config = JSON.parse(this.querySelector('[data-gf-config]').textContent);
      this.finderTracker = attachMeasurement(this, config);
      const close = () => { shell.open = false; launcher.focus(); };
      this.querySelector('[data-gf-close]').addEventListener('click', close);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && shell.open) { event.preventDefault(); close(); }
      });
      const load = async () => {
        if (!shell.open || this.finderMounted || this.finderLoading) return;
        this.finderLoading = true;
        body.textContent = config.copy.widget.loading;
        try {
          const finder = await import(this.dataset.moduleUrl);
          await finder.mount(this, config);
          this.finderMounted = true;
        } catch (error) {
          this.finderTracker.event('error', {error: 'module_load'});
          body.textContent = config.copy.widget.load_error;
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'gf-text-button';
          retry.textContent = config.copy.widget.retry;
          retry.addEventListener('click', load);
          body.append(retry);
        } finally {
          this.finderLoading = false;
        }
      };
      shell.addEventListener('toggle', () => {
        this.finderTracker.event(shell.open ? 'open' : 'close', {}, shell.open ? 'once' : '');
        load();
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
